import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const login = async () => {
    setError("");
    setBusy(true);
    try {
      const res = await API.post("/users/login", {
        email,
        password
      });

      localStorage.setItem("token", res.data.token);
      onLogin();
      navigate("/", { replace: true });
    } catch (err) {
      setError("Credenciales incorrectas o servidor no disponible.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Bienvenido</h1>
        <p className="lead">Ingresá a tu cuenta SVC Vikingo</p>

        {error ? (
          <div className="login-card__error" role="alert">
            {error}
          </div>
        ) : null}

        <div className="field">
          <label className="field-label" htmlFor="login-email">
            Email
          </label>
          <input
            id="login-email"
            className="input"
            type="email"
            autoComplete="username"
            placeholder="admin@ejemplo.cl"
            value={email}
            onChange={e => {
              setEmail(e.target.value);
              if (error) setError("");
            }}
            aria-invalid={error ? "true" : "false"}
            disabled={busy}
          />
        </div>

        <div className="field">
          <label className="field-label" htmlFor="login-password">
            Contraseña
          </label>
          <input
            id="login-password"
            className="input"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••"
            value={password}
            onChange={e => {
              setPassword(e.target.value);
              if (error) setError("");
            }}
            onKeyDown={e => e.key === "Enter" && !busy && login()}
            aria-invalid={error ? "true" : "false"}
            disabled={busy}
          />
        </div>

        <button type="button" className="btn btn-primary" onClick={login} disabled={busy}>
          {busy ? "Ingresando…" : "Ingresar"}
        </button>
      </div>
    </div>
  );
}

export default Login;
